import User from '../../../client/models/user'
import UserAnswer from './user_answer'
import Vote from './vote'
import Comment from './comment'
import Material from './material'
import QuestionRelative from './question_relative'

export default class UserQuestion {
  readonly id: number
  readonly title: string
  readonly from: string
  readonly tags: string[]
  readonly questionType: string
  readonly targetType: string
  readonly targetId: number
  readonly user: User
  readonly comments: Comment[] = []
  readonly userAnswers: UserAnswer[] = []
  readonly answersCount: number
  readonly votes: Vote[] = []
  readonly voteValues: number
  readonly materials: Material[] = []
  readonly createdAt: string
  readonly updatedAt: string
  readonly renderedBody: string
  readonly questionRelatives: QuestionRelative[] = []
  readonly resolvedAt: string | null
  body: string
  files: File[] = []
  showCommentForm: boolean = false
  isEditing: boolean = false

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.title = data.title
    this.body = data.body
    this.renderedBody = data.renderedBody
    this.from = data.from
    this.tags = data.tags
    this.questionType = data.questionType
    this.targetType = data.targetType
    this.targetId = data.targetId
    this.voteValues = data.voteValues
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.answersCount = data.answersCount
    this.resolvedAt = data.resolvedAt || null

    this.files = []
    this.showCommentForm = false
    this.isEditing = false

    if (data.user) {
      this.user = new User(data.user)
    }
    if (data.comments) {
      this.comments = data.comments.map((element) => new Comment(element))
    }
    if (data.answers) {
      this.userAnswers = data.answers.map((element) => new UserAnswer(element))
    }
    if (data.votes) {
      this.votes = data.votes.map((element) => new Vote(element))
    }
    if (data.materials) {
      this.materials = data.materials.map((element) => new Material(element))
    }
    if (data.questionRelatives) {
      this.questionRelatives = data.questionRelatives.map((element) => new QuestionRelative(element))
    }
  }

  public get answerCount(): number {
    return this.userAnswers.length
  }

  public get voteMark(): number {
    return this.votes.reduce((sum, vote) => sum + vote.value, 0)
  }

  public get relativeCourse(): string {
    if (this.questionRelatives.length > 0) {
      let course = this.questionRelatives.find((relative) => relative.relativeableType == 'Course')
      return course.name
    }

  }

  public get relativeLesson(): string {
    if (this.questionRelatives.length > 0) {
      let lesson = this.questionRelatives.find((relative) => relative.relativeableType == 'Lesson')
      return lesson.name
    }
  }
}
